<template>
  <svg class="loader text-fgr-hint" :width="size" :height="size" viewBox="0 0 50 50">
    <circle class="path" cx="25" cy="25" r="20" fill="none" stroke-width="4" />
  </svg>
</template>

<script setup lang="ts">
  defineOptions({
    name: "CircularLoader",
  });

  withDefaults(
    defineProps<{
      size?: number;
    }>(),
    {
      size: 64,
    }
  );
</script>

<style scoped>
  .loader {
    animation: spin 1s linear infinite;
  }

  .path {
    stroke: currentColor;
    stroke-linecap: round;
    stroke-dasharray: 90, 150;
    stroke-dashoffset: 0;
  }

  @keyframes spin {
    to {
      transform: rotate(360deg);
    }
  }
</style>
